import { setupMarkdownToolPage } from './shared/index.js';
import { applyImageMode, convertOfficeFile, OFFICE_MAX_INPUT_BYTES, removeFrontmatter, requireUploadConsent } from './formats/docx/office-client.js';

function isEpub(file) {
  return Boolean(file && (/\.epub$/i.test(file.name) || file.type === 'application/epub+zip'));
}

export function initEpubPage(root = document) {
  const images = root.querySelector('#epub-images');
  const frontmatter = root.querySelector('#epub-frontmatter');
  const uploadConsent = root.querySelector('#upload-consent');
  let sourceFile = null;
  const page = setupMarkdownToolPage({
    root,
    defaultFileName: 'epub-document',
    onFiles: (files) => {
      const file = files?.[0];
      if (!file) return;
      try { requireUploadConsent(uploadConsent); } catch (error) { sourceFile = null; page.setReady(false); page.setStatus(error.message, 'error'); return; }
      if (files.length > 1) { page.setStatus('Choose one EPUB file at a time.', 'error'); return; }
      if (!isEpub(file)) { page.setStatus('Choose an EPUB file.', 'error'); return; }
      if (!file.size || file.size > OFFICE_MAX_INPUT_BYTES) {
        page.setStatus('The EPUB file must be between 1 B and 50.0 MB.', 'error');
        return;
      }
      sourceFile = file;
      page.setReady(true);
      page.setStatus(`${file.name} is ready. Choose image and frontmatter handling, then convert.`, 'success');
    },
  });
  uploadConsent?.addEventListener('change', () => {
    if (!uploadConsent.checked) page.setReady(false);
    else if (sourceFile) page.setReady(true);
  });
  page.elements.convertButton?.addEventListener('click', () => {
    if (!sourceFile) return;
    try { requireUploadConsent(uploadConsent); } catch (error) { page.setStatus(error.message, 'error'); return; }
    page.runConversion(async ({ signal, report }) => {
      let output = await convertOfficeFile(sourceFile, 'epub', {}, { signal, report, consent: Boolean(uploadConsent?.checked) });
      if (images && !images.checked) output = applyImageMode(output, 'omit');
      if (frontmatter && !frontmatter.checked) output = removeFrontmatter(output);
      report('Markdown is ready.', 1);
      return output;
    }).catch(() => {});
  });
  page.elements.clearButton?.addEventListener('click', () => {
    sourceFile = null;
    page.setReady(false);
    page.result.clear();
    page.setStatus('Source cleared.');
  });
  page.setReady(false);
  return { page, get sourceFile() { return sourceFile; } };
}

if (typeof document !== 'undefined' && document.documentElement.dataset.markdownFormat === 'epub') initEpubPage();
